import React, {Component} from 'react';
import {gpn} from "../GPN"
import config from "../config";
import req from "../req";
import Back from "../sections/Back";
import Field from "../sections/MUI/Field";
import InfiniteScroll from "react-infinite-scroller";
import Collapsible from "react-collapsible";
import Select from "../sections/MUI/Select";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import Modal from "../sections/MUI/Modal";
import jMoment from "jalali-moment";
import DateField from "../sections/MUI/DateField";

class Payments extends Component {

    state = {
        payments: [],
        page: 1,
        hasNextPage: true,
        totalPages: null,

        start: jMoment().startOf("jMonth").format("jYYYY/jMM/jDD"),
        end: jMoment().endOf("jMonth").format("jYYYY/jMM/jDD"),
        sum: null,

        search: "",
        status: "all",
        modalPayments: false
    };

    componentDidMount() {
        let {start, end} = this.state;
        config.scrollTop();
        this.getPaymentsStatistics(start, end)
    }

    getPaymentsStatistics(start = "", end = "") {
        req.get(`/payment/statistics?start=${start}&end=${end}`)
            .then(r => {
                this.setState({
                    sum: r
                });
            });
    }

    getPayments(page, search = "", status = "all") {
        req.get(`/payment?page=${page}&s=${search}&status=${status}`)
            .then(r => {
                const payments = r.payments;
                this.setState({
                    payments: page > 1 ? [...this.state.payments, ...payments.docs] : payments.docs,
                    page: page + 1,
                    hasNextPage: payments.hasNextPage,
                    totalPages: payments.totalPages
                });
            });

    }

    statusColor(status = "") {
        let color = "#FF3D00";
        if (status.includes("پرداخت موفق")) {
            color = "#139f01";
        } else if (status.includes("پرداخت ناموفق")) {
            color = "#c00e0e"
        }
        return color;
    }

    setStatus(id, status = "پرداخت نشده!") {
        toast.info("در حال ثبت وضعیت ...");
        req.put(`/payment`, {
            id,
            status
        })
            .then(r => {
                toast.success("با موفقیت ثبت شد.");
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    delete(index = -1, id = "") {
        let {payments} = this.state;
        toast.info("در حال حذف ...");

        req.delete(`/payment?id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد!");
                if (index !== -1) {
                    payments.splice(index, 1);
                    this.setState({
                        payments
                    });
                }
            })
            .catch(err => {
                config.handleError(err);
            });

    }

    render() {
        let {
            payments, page, hasNextPage, search, status, sum, modalPayments,
            start, end
        } = this.state;
        return (
            <div className="payments">
                <Modal display={modalPayments}
                       title="آمار"
                       onCloseClick={() => this.setState({modalPayments: false})}>
                    {
                        sum ?
                            <div className="row justify-content-between">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-6">
                                            <DateField value={start}
                                                       label="از"
                                                       onChange={(unix, formatted) => {
                                                           this.setState({start: formatted});
                                                           this.getPaymentsStatistics(formatted, end);
                                                       }}/>
                                        </div>
                                        <div className="col-6">
                                            <DateField value={end}
                                                       label="تا"
                                                       onChange={(unix, formatted) => {
                                                           this.setState({end: formatted});
                                                           this.getPaymentsStatistics(start, formatted);
                                                       }}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row justify-content-center">
                                        <h4 className="sum">
                                            <span>پرداخت موفق بر اساس تاریخ:</span><span>{config.priceFormatter(sum.byDate)}</span>
                                        </h4>
                                    </div>
                                    <br/>
                                </div>
                                <div className="col-md-3">
                                    <h4 className="sum">
                                        <span>پرداخت موفق امروز:</span><span>{config.priceFormatter(sum.toDay)}</span>
                                    </h4>
                                </div>
                                <div className="col-md-3">
                                    <h4 className="sum">
                                        <span>کل پرداخت موفق:</span><span>{config.priceFormatter(sum.all)}</span>
                                    </h4>
                                </div>
                                <div className="col-md-3">
                                    <h4 className="sum">
                                        <span> پرداخت موفق این ماه:</span><span>{config.priceFormatter(sum.toMonth)}</span>
                                    </h4>
                                </div>
                                <div className="col-md-3">
                                    <h4 className="sum">
                                        <span> پرداخت موفق ماه گذشته:</span><span>{config.priceFormatter(sum.lastMonth)}</span>
                                    </h4>
                                </div>
                            </div>
                            : null
                    }

                </Modal>
                <Back {...this.props}/>
                <br/>
                <div className="row justify-content-center">

                    <div className="col-md-5">
                        <Select name="status"
                                value={status}
                                options={[
                                    {t: "همه", v: "all"},
                                    {t: "پرداخت موفق", v: "پرداخت موفق"},
                                    {t: "پرداخت موفق با کارتخوان", v: "پرداخت موفق با کارتخوان"},
                                    {t: "پرداخت ناموفق", v: "پرداخت ناموفق"},
                                    {t: "پرداخت نشده!", v: "پرداخت نشده!"}
                                ]}
                                onChange={(name, value) => {
                                    this.setState({[name]: value});
                                    this.getPayments(1, search, value);
                                }}/>
                    </div>
                    <div className="col-md-7">
                        <Field name="search"
                               value={search}
                               label="جستجو ..."
                               maxLength={355}
                               onChange={(name, value) => {
                                   this.setState({[name]: value});
                                   this.getPayments(1, value, status);
                               }}/>
                    </div>
                </div>
                <br/>

                <div className="row">
                    <div className="col-md-4">
                        <Button icon="statistics" onClick={() => this.setState({modalPayments: true})}>نمایش
                            آمار</Button>
                    </div>
                </div>
                <br/>
                <div className="list">
                    <InfiniteScroll
                        pageStart={1}
                        loadMore={() => this.getPayments(page, search, status)}
                        hasMore={hasNextPage}
                        loader={<div className="loader" key={0}>دریافت ...</div>}>
                        {
                            payments ? payments?.map((p, i) =>
                                    <article key={"payment" + i}>
                                        <Collapsible
                                            trigger={
                                                <div className="collapse-header">
                                                    <div className="user">
                                                        <div className="row">
                                                            <div className="status-circle"
                                                                 style={{backgroundColor: this.statusColor(p.status)}}>
                                                            </div>
                                                            {
                                                                p.user ?
                                                                    <>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="full-name">{p.user.fullName}</div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="phone">({p.user.phone})
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div className="code">
                                                                                <span>کد:</span><span>{p.code}</span></div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="full-name">نامشخص
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="phone">(این کاربر وجود ندارد)
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div className="code">
                                                                                <span>کد:</span><span>{p.code}</span></div>
                                                                        </div>
                                                                    </>
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                            }
                                            transitionTime={50}>
                                            <div className="body">

                                                <div className="info">
                                                    {p.Authority !== "" ?
                                                        <p><span>شناسه یکتا:</span><span>{p.Authority}</span></p>
                                                        : null
                                                    }
                                                    {
                                                        p.RefID !== "" ?
                                                            <p><span>کد پیگیری:</span><span>{p.RefID}</span></p>
                                                            : null
                                                    }
                                                    {p.transid !== "" ?
                                                        <>
                                                            <p className="transid">
                                                                <span>شناسه تراکنش:</span><span>{p.transid}</span></p>
                                                            <p className="tracking-number">
                                                                <span>کد پیگیری:</span><span>{p.tracking_number}</span></p>
                                                            <p className="cardnumber">
                                                                <span>از شماره کارت:</span><span>{p.cardnumber}</span></p>
                                                            <p className="cardnumber">
                                                                <span>بانک:</span><span>{p.bank}</span></p><p
                                                            className="cardnumber">
                                                            <span>وضعیت پرداخت از بانک:</span><span>{p.paymentStatus.toString() === "1" ? "موفق" : "ناموفق"}</span>
                                                        </p>
                                                        </>
                                                        : null}
                                                    <p>
                                                        <span>مبلغ:</span><span>{config.priceFormatter(p.amount)}&nbsp;تومان</span>
                                                    </p>
                                                </div>
                                                <Select name="status"
                                                        value={p.status}
                                                        label="وضعیت"
                                                        options={[
                                                            {t: "پرداخت نشده!", v: "پرداخت نشده!"},
                                                            {t: "پرداخت موفق", v: "پرداخت موفق"},
                                                            {t: "پرداخت موفق با کارتخوان", v: "پرداخت موفق با کارتخوان"},
                                                            {t: "پرداخت ناموفق", v: "پرداخت ناموفق"}
                                                        ]}
                                                        onChange={(name, value) => {
                                                            let mPayments = payments;
                                                            mPayments[i]["status"] = value;
                                                            this.setState({payments: mPayments});
                                                            this.setStatus(p.id, value);
                                                        }}/>
                                                <p className="created-at"><span>ثبت شده در:</span><span>{p.createdAt}</span>
                                                </p>

                                                <br/><br/>
                                                <div className="row justify-content-end">
                                                    <div className="col-4">
                                                        <Button icon="trash"
                                                                backgroundColor="#c00e0e"
                                                                onDoubleClick={() => this.delete(i, p.id)}>حذف
                                                            پرداخت</Button>
                                                    </div>
                                                </div>


                                            </div>
                                        </Collapsible>


                                    </article>)
                                : null
                        }
                    </InfiniteScroll>
                </div>
            </div>
        );
    }
}

export default gpn(Payments);